export default {"src":"/_next/static/media/hourse.b0cbf4bd.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};